import React from "react";
import BackImg from "@assets/images/stepsBack.jpg";
import ContactUsForm from "@components/common/ContactUsForm";
import { useTranslation } from "react-i18next";

const Contact = () => {
  const {t} = useTranslation();
  return (
    <div
      className={`bg-cover rounded-[17px] py-[100px] px-7 `}
      style={{ backgroundImage: `url(${BackImg})` }}
    >
      <div className="grid grid-cols-1 md:grid-cols-2 gap-[20px]">
        <div className="flex flex-col justify-center">
          <h1 className="text-white font-[800] font-[Lato] text-[28px]">
            {t("Contact Information")}
          </h1>
          <p className="text-white font-[400] font-[Lato] text-[18px] mt-2">
            {t("Got a question")}
          </p>
          <h1 className="text-white font-[800] font-[Lato] text-[28px] mt-[50px]">
            {t("Still need help?")}
          </h1>
          <p className="text-white font-[400] font-[Lato] text-[18px] mt-2">
            {t("No problem")}
          </p>
        </div>
        <ContactUsForm />
      </div>
    </div>
  );
};

export default Contact;
